import React from 'react';
import { Alert } from 'reactstrap';
import i18next from 'i18next';

import { NormalizedRestaurant } from 'types';
import Shapes from 'shapes/main';
import { hasAnyOrders } from 'utils/restaurant';

const PushNotificationErrorAlert = (props: {
  restaurant: NormalizedRestaurant;
}) => {
  if (!hasAnyOrders(props.restaurant)) {
    return null;
  }
  return (
    <Alert color="danger">
      <p>{i18next.t('push-notification-error-alert.error-message')}</p>
      <p>{i18next.t('push-notification-error-alert.usage-hint')}</p>
    </Alert>
  );
};

PushNotificationErrorAlert.propTypes = {
  restaurant: Shapes.restaurantShape.isRequired,
};

export default PushNotificationErrorAlert;
